export const MODAL_NAMES = {
  MOBILE_PLAN_ASSISTANCE: 'mobile-plan-assistance',
}
